import { useClassNames } from '@magnetic/hooks';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const BreadcrumbSingle = /* @__PURE__ */ __name(({
  children,
  className
}) => {
  const classNames = useClassNames("mds-rebuild-breadcrumb", className);
  return /* @__PURE__ */ React.createElement("nav", {
    className: classNames
  }, children);
}, "BreadcrumbSingle");

export { BreadcrumbSingle };
//# sourceMappingURL=breadcrumb-single.js.map
